export const BASE_URL_API = "https://ipp.styleoutlet.vn";
export const DAFC_URL = "https://ippgroup.vn/"
